import { forwardRef, ForwardRefRenderFunction, useImperativeHandle } from "react";
import { ReactNode, useState } from "react";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@altimateai/lego";
import { Button, ButtonProps } from "@altimateai/lego";

interface Props {
  title?: string;
  buttonProps?: ButtonProps;
  buttonText?: ReactNode | string;
  icon?: ReactNode;
  onClose?: () => void;
  onOpen?: () => void;
  children: ReactNode;
  backdrop?: boolean;
  style?: React.CSSProperties;
}

export interface DrawerRef {
  close: () => void;
  open: () => void;
}

const Drawer: ForwardRefRenderFunction<DrawerRef, Props> = (
  { buttonProps, buttonText, icon, title, onClose, children, onOpen, backdrop = true, style = {} },
  ref
) => {
  const [show, setShow] = useState(false);

  const handleOpenChange = (open: boolean) => {
    setShow(open);
    if (!open) {
      onClose?.();
    } else {
      onOpen?.();
    }
  };

  useImperativeHandle(ref, () => ({
    close() {
      setShow(false);
    },
    open() {
      setShow(true);
    },
  }));

  return (
    <Sheet open={show} onOpenChange={handleOpenChange}>
      {buttonText || icon ? (
        <SheetTrigger asChild>
          <Button {...buttonProps}>
            {icon && icon} {buttonText}
          </Button>
        </SheetTrigger>
      ) : null}
      <SheetContent
        side="right"
        className="!al-max-w-[50vw] al-min-w-[600px]"
        style={style}
        onInteractOutside={e => {
          if (!backdrop) {
            e.preventDefault();
          }
        }}
      >
        <SheetHeader>{title && <SheetTitle>{title}</SheetTitle>}</SheetHeader>
        <div className="al-flex-1">{children}</div>
      </SheetContent>
    </Sheet>
  );
};

export default forwardRef(Drawer);
